module.exports = "<div *ngIf=\"hero\">\n\n  <h2>{{ hero.name | uppercase }} Details</h2>\n  <div><span>id: </span>{{hero.id}}</div>\n  <div>\n    <label>name:\n      <input [(ngModel)]=\"hero.name\" placeholder=\"name\"/>\n    </label>\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/hero-detail/hero-detail.component.html
// module id = ./src/app/components/hero-detail/hero-detail.component.html
// module chunks = main